import { find, isEmpty } from "lodash";
import INVOICEITEM from "@/constants/invoice-item";
import InvoiceItemService from "@/services/invoice/invoice-item";
import BILLINGS from "@/constants/billings";
/**
 * @method Invoice Item Mixin
 * @descriotion The function is too long so this mixin only for the function that used when fields
 * item, patient, quantity, unit price, fees, discount and print_on_invoice changed
 */
export default {
    data() {
        return {};
    },
    computed: {
        isNew() {
            return this.invoiceItem == null;
        }
    },
    methods: {
        clearError(key) {
            this.formError = this.formError.filter(err => err !== key);
        },
        checkBoolean(variable) {
            return variable == true || variable == 1;
        },
        /**
         * @method calculateDiscountAndTotalPriceEstimate
         * @description parent function that either trigger function calculate_item_price_estimate or calculate_discount before recalculate_estimate_total and check_negative_invoice_total
         */
        async calculateDiscountAndTotalPriceEstimate(
            isCalculateItemPrice = true,
            storeDiscount = true,
            level = null
        ) {
            if (isCalculateItemPrice)
                await this.calculate_item_price_estimate(level);
            else this.validate_quantity(level);

            if (this.data.item) {
                await this.calculate_discount(storeDiscount);
            }

            await this.recalculate_estimate_total();
            await this.check_negative_invoice_total();

            return;
        },

        async calculateDiscountAndTotalPrice(
            isCalculateItemPrice = true,
            storeDiscount = true,
            isChangeUnitPrice = false
        ) {
            if (isCalculateItemPrice) {
                await this.calculate_item_price(!isChangeUnitPrice);
            }

            if (this.data.item) {
                await this.calculate_discount(storeDiscount);
            }

            await this.recalculate_invoice_total();
            await this.check_negative_invoice_total();

            return;
        },
        /**
         * @method switch_discount
         * @description hide discount amount and type if not custom and update them based on the discount selected
         */
        switch_discount() {
            this.alertMessage = null;
            this.canProceed = true;
            this.clearError("discount");
            this.data.discountAmount = null;
            this.data.discountType = 0;

            if (
                this.data.discountId &&
                ![
                    INVOICEITEM.DISCOUNTS.CUSTOM.id,
                    INVOICEITEM.DISCOUNTS.INVOICE.id,
                    INVOICEITEM.DISCOUNTS.WELLNESS.id
                ].includes(this.data.discountId)
            ) {
                let discount = find(this.discountOptions, {
                    id: this.data.discountId
                });
                if (discount) {
                    if (discount.all_category) {
                        this.data.discountAmount = discount.amount;
                        this.data.discountType = discount.type;
                    } else if (!isEmpty(discount.discount_categories)) {
                        this.data.discountAmount =
                            discount.discount_categories[0].amount;
                        this.data.discountType =
                            discount.discount_categories[0].type;
                    } else {
                        this.alertMessage =
                            INVOICEITEM.ALERT_MESSAGE.DISCOUNT_CANNT_BE_APPLIED;
                        this.canProceed = false;
                        this.$emit("scroll-top");
                        this.formError.push("discount");
                    }
                }
            } else {
                this.data.is_non_plan_item = false;

                switch (this.data.discountId) {
                    case INVOICEITEM.DISCOUNTS.WELLNESS.id:
                        this.data.discountAmount = this.data.non_plan_discount;
                        this.data.discountType = 0;
                        break;
                }
            }
            return;
        },
        async calculate_fee() {
            if (this.feesId.length == 0) {
                // check for feesId before proceeding because the API require fees
                this.data.iitem_fee_price = 0;
                return;
            }
            this.loading.push("calculate_fee");
            await InvoiceItemService.getFeePrices({
                fees: this.feesId,
                invoice_item_id: this.invoiceItem ? this.invoiceItem.id : null,
                isAfterHours: this.invoiceItem
                    ? this.invoiceItem.is_after_hours
                    : null
            })
                .then(res => {
                    this.data.iitem_fee_price = res.fees_amount;
                    this.data.default_iitem_fee_price = res.fees_amount;
                })
                .finally(() => {
                    this.removeLoadingItem("calculate_fee");
                });
        },
        /**
         * @use estimate only
         * @method recalculate_estimate_total
         * @description recalculate estimate total if there are changes in discount, fees, quantity, print on estimate or etc.
         */
        recalculate_estimate_total() {
            let quantityMin = parseFloat(this.data.minQuantity);
            let quantityMax = parseFloat(this.data.maxQuantity);
            let itemUnitPriceMinOri = this.data.iitem_min_unit_price_ori;
            let itemUnitPriceMaxOri = this.data.iitem_max_unit_price_ori;
            let itemUnitPriceMin = parseFloat(this.data.minUnitPrice);
            let itemUnitPriceMax = parseFloat(this.data.maxUnitPrice);
            let iitemFeePrice = this.data.iitem_fee_price;
            let iitemDiscType = this.data.discountType;
            let iitemDiscount = this.data.discountAmount;
            let minPrice = this.data.minimum_price;
            let minPriceType = this.data.minimum_price_type;
            let printOnInvoice = this.data.isPrintOnInvoice;
            let discountMinOri = this.data.discountMinOri;
            let discountMaxOri = this.data.discountMaxOri;
            let isMinPriceTier = this.data.is_min_price_tier;

            var totalMin = 0;
            var totalMax = 0;
            var priceAndFeeMax = 0;
            var discountMin = discountMinOri;
            var discountMax = discountMaxOri;

            if (!quantityMin) quantityMin = 0;
            if (!quantityMax) quantityMax = 0;
            if (!itemUnitPriceMin) itemUnitPriceMin = 0;
            if (!itemUnitPriceMax) itemUnitPriceMax = 0;
            if (!iitemDiscount) iitemDiscount = 0;
            if (!iitemFeePrice) iitemFeePrice = 0;

            let unitPriceMin = itemUnitPriceMin;
            let unitPriceMax = itemUnitPriceMax;

            if (
                isMinPriceTier == 1 ||
                isMinPriceTier == 2 ||
                isMinPriceTier == 4 ||
                isMinPriceTier == 5
            ) {
                unitPriceMin = itemUnitPriceMinOri;
            }
            if (
                isMinPriceTier == 1 ||
                isMinPriceTier == 3 ||
                isMinPriceTier == 4 ||
                isMinPriceTier == 6
            ) {
                unitPriceMax = itemUnitPriceMaxOri;
            }
            // let priceAndFeeMin = quantityMin * unitPriceMin + iitemFeePrice;
            // if (quantityMax > 0) {
            //     priceAndFeeMax = quantityMax * unitPriceMax + iitemFeePrice;
            // } else if (this.data.maxUnitPrice) {
            //     priceAndFeeMax =
            //         quantityMin * this.data.maxUnitPrice + iitemFeePrice;
            // }
            let minIsBaseAndChangePrice =
                this.data.item.unit_price_ori.toFixed(2) == unitPriceMin;
            let maxIsBaseAndChangePrice =
                this.data.item.unit_price_ori.toFixed(2) == unitPriceMax;

            if (minIsBaseAndChangePrice) {
                this.data.minUnitPrice2 = this.data.item.unit_price_ori;
            } else {
                this.data.minUnitPrice2 = null;
            }

            if (maxIsBaseAndChangePrice) {
                this.data.maxUnitPrice2 = this.data.item.unit_price_ori;
            } else {
                this.data.maxUnitPrice2 = null;
            }

            let priceAndFeeMin =
                quantityMin *
                    (minIsBaseAndChangePrice
                        ? this.data.item.unit_price_ori
                        : unitPriceMin) +
                iitemFeePrice;

            if (quantityMax > 0) {
                priceAndFeeMax =
                    quantityMax *
                        (maxIsBaseAndChangePrice
                            ? this.data.item.unit_price_ori
                            : unitPriceMax) +
                    iitemFeePrice;
            } else if (this.data.maxUnitPrice) {
                priceAndFeeMax =
                    quantityMin *
                        (maxIsBaseAndChangePrice
                            ? this.data.item.unit_price_ori
                            : unitPriceMax) +
                    iitemFeePrice;
            }

            if (iitemDiscType == 1) {
                discountMin = iitemDiscount;
                discountMax = iitemDiscount;

                if (priceAndFeeMin > 0 && priceAndFeeMin - iitemDiscount < 0) {
                    // --- discount cannot be greater than price
                    this.pushAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                    );
                    this.canProceed = false;
                } else {
                    if (
                        this.alertMessages.includes(
                            INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                        )
                    ) {
                        this.removeAlertMessages(
                            INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                        );
                    }
                    this.canProceed = true;
                }
                totalMin = priceAndFeeMin - iitemDiscount;
                if (
                    (itemUnitPriceMin == 0 && iitemFeePrice == 0) ||
                    quantityMin == 0
                ) {
                    discountMin = 0;
                    totalMin = 0;
                }

                // if (quantityMax > 0) {
                //     totalMax = priceAndFeeMax - iitemDiscount;
                // } else  {
                totalMax = priceAndFeeMax - iitemDiscount;
                // }
            } else {
                if (
                    this.alertMessages.includes(
                        INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                    )
                ) {
                    this.removeAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                    );
                }
                this.canProceed = true;

                discountMin = priceAndFeeMin * (iitemDiscount / 100);
                totalMin = priceAndFeeMin - discountMin;

                if (
                    (itemUnitPriceMin == 0 && iitemFeePrice == 0) ||
                    quantityMin == 0
                ) {
                    discountMin = 0;
                    totalMin = 0;
                }
                if (priceAndFeeMax) {
                    discountMax = priceAndFeeMax * (iitemDiscount / 100);
                    totalMax = priceAndFeeMax - discountMax;
                } else {
                    discountMax = 0;
                    totalMax = 0;
                }
            }

            // GIT #1979
            let minMinPrice = minPrice;
            let maxMinPrice = minPrice;
            if (minPriceType == 2) {
                minMinPrice = minPrice * quantityMin;
                maxMinPrice = minPrice * quantityMax;
            }

            //check whether need to apply min price
            if (minPrice > 0) {
                if (
                    (isMinPriceTier == 1 || isMinPriceTier == 2) &&
                    totalMin < minMinPrice &&
                    quantityMin > 0
                ) {
                    totalMin = minMinPrice;
                    if (priceAndFeeMin - minMinPrice >= discountMin) {
                        // discount_min = parseFloat(price_n_fee_min - minimum_price).toFixed(2);
                    } else {
                        discountMin = 0;
                    }
                }
                if (
                    (isMinPriceTier == 1 || isMinPriceTier == 3) &&
                    totalMax < maxMinPrice &&
                    quantityMax > 0
                ) {
                    totalMax = maxMinPrice;
                    if (priceAndFeeMax && priceAndFeeMax - maxMinPrice > 0) {
                        discountMax = priceAndFeeMax - maxMinPrice;
                    } else {
                        discountMax = 0;
                    }
                }
            }
            //update field
            if (printOnInvoice == 1) {
                this.data.total_item_price_min = this.roundOff(
                    totalMin
                ).toFixed(2);

                if (quantityMax > 0) {
                    this.data.total_item_price_max = this.roundOff(
                        totalMax
                    ).toFixed(2);
                } else {
                    this.data.total_item_price_max = totalMax
                        ? parseFloat(
                              totalMax > totalMin ? totalMax : totalMin
                          ).toFixed(2)
                        : parseFloat(0).toFixed(2);
                }

                this.data.discountMin = this.roundOff(discountMin).toFixed(2);
                this.data.discountMax =
                    discountMax && this.data.maxUnitPrice != 0
                        ? this.roundOff(discountMax).toFixed(2)
                        : parseFloat(0).toFixed(2);
            }
        },
        recalculate_invoice_total() {
            let iitem_fee_price = this.data.iitem_fee_price;
            let is_min_price_tier = this.data.is_min_price_tier;
            let minimum_price = this.data.minimum_price;
            let minimum_price_type = this.data.minimum_price_type;
            let quantity = this.data.quantity;
            let unit_price_ori = this.data.iitem_unit_price_ori;
            let iitem_unit_price = this.data.unitPrice;
            let iitem_discount = this.data.discountAmount;
            let iitem_discount_type = this.data.discountType;
            let print_on_invoice = this.data.isPrintOnInvoice;
            let is_plan_active = this.data.is_plan_active;
            let plan_item_balance = this.data.plan_item_balance;
            let fees = this.feesId;
            let balance = quantity;
            let new_price = 0;
            let plan_price = 0;
            let disc_price = 0;
            let isValidPlan = false;
            let isExceed = false;
            let unit_price = 0;

            if ((Array.isArray(fees) && fees.length == 0) || fees == null) {
                iitem_fee_price = 0;
            }

            if (iitem_unit_price != null) {
                unit_price = iitem_unit_price;
            }

            if (is_min_price_tier == 1 || is_min_price_tier == 2) {
                unit_price = unit_price_ori;
            }

            if (!iitem_discount) {
                iitem_discount = 0;
            }

            if (quantity > 0 && this.data.is_plan_item && is_plan_active > 0) {
                var bal = plan_item_balance - quantity;
                balance = Math.abs(bal);
                isValidPlan = true;
                plan_price = (quantity * unit_price).toFixed(2);

                if (bal < 0) {
                    isExceed = true;
                    plan_price = (plan_item_balance * unit_price).toFixed(2);
                }

                this.data.iitem_plan_price = plan_price;
                this.data.iitem_price = Math.abs(balance) * unit_price;
            }

            if (iitem_discount_type == 1) {
                //$ discount
                if ((isExceed && isValidPlan) || (!isExceed && !isValidPlan)) {
                    // --- rounded total item price because the discount has been formatted to 2 dp
                    let total_item_price = (
                        Math.round(unit_price * balance * 100) / 100
                    ).toFixed(2);
                    new_price =
                        parseFloat(total_item_price) +
                        parseFloat(iitem_fee_price) -
                        parseFloat(iitem_discount);
                } else {
                    new_price =
                        parseFloat(iitem_fee_price) -
                        parseFloat(iitem_discount);
                }
                disc_price = iitem_discount;
            } else {
                // %- discount
                if (
                    this.alertMessage ==
                    INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                ) {
                    this.alertMessage = null;
                    this.canProceed = true;
                }

                let price = parseFloat(iitem_fee_price);

                if ((isExceed && isValidPlan) || (!isExceed && !isValidPlan)) {
                    price =
                        parseFloat(unit_price * balance) +
                        parseFloat(iitem_fee_price);
                }

                disc_price = parseFloat(
                    price * (parseFloat(iitem_discount) / 100)
                );
                new_price = parseFloat(price - disc_price);
            }

            // to check whether invoice item become negative, hence will prevent to continue
            if (new_price < 0) {
                // --- discount cannot be greater than price
                this.alertMessage =
                    INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE;
                this.canProceed = false;
                this.$emit("scroll-top");
            } else {
                if (
                    this.alertMessage ==
                    INVOICEITEM.ALERT_MESSAGE.DISCOUNT_ITEM_NEGATIVE
                ) {
                    this.alertMessage = null;
                    this.canProceed = true;
                }
            }
            // GIT #1979
            // if minimum price type == UOM, minimum price = quantity * minimum price
            if (minimum_price_type == 2) {
                minimum_price = minimum_price * balance;
            }

            if (
                is_min_price_tier == 1 &&
                minimum_price > 0 &&
                new_price < parseFloat(minimum_price)
            ) {
                if ((isExceed && isValidPlan) || (!isExceed && !isValidPlan)) {
                    new_price = minimum_price;
                }
            }

            if (parseFloat(quantity) == 0) {
                new_price = 0;
            }
            if (print_on_invoice) {
                if (
                    parseFloat(balance) > 0 &&
                    parseFloat(minimum_price) > 0 &&
                    parseFloat(new_price).toFixed(2) ==
                        parseFloat(minimum_price)
                ) {
                    if (isValidPlan) {
                        if (isExceed) {
                            this.data.total_item_price =
                                this._toNumber((new_price * 100) / 100, 2) +
                                " (minimum price, " +
                                plan_price +
                                "  included in plan)";
                        } else {
                            this.data.total_item_price =
                                this._toNumber((new_price * 100) / 100, 2) +
                                " (" +
                                plan_price +
                                "  included in plan)";
                        }
                    } else {
                        this.data.total_item_price =
                            ((new_price * 100) / 100).toFixed(2) +
                            " (minimum price)";
                    }
                } else {
                    if (!isValidPlan) {
                        this.data.total_item_price = this._toNumber(
                            (new_price * 100) / 100,
                            2
                        );
                    } else {
                        if (!isExceed) {
                            this.data.total_item_price =
                                "0.00 (" + plan_price + "  included in plan)";
                        } else {
                            this.data.total_item_price =
                                this._toNumber((new_price * 100) / 100, 2) +
                                " (" +
                                plan_price +
                                "  included in plan)";
                        }
                    }
                }
            } else {
                this.data.total_item_price = "0.00 (excluded from total)";
            }

            if (
                this.alertMessage == INVOICEITEM.ALERT_MESSAGE.INVOICE_NEGATIVE
            ) {
                this.alertMessage = null;
                this.canProceed = true;
            }
        },
        /**
         * @use estimate and invoice
         * @method verify_override_disc_status
         */
        verify_override_disc_status() {
            let print_on_invoice = this.data.isPrintOnInvoice;
            let is_invoice = this.isInvoice;
            let flag = 0;

            // NOT SURE WHY BOTH FLAG=1, need to check in CI
            // maybe the flag = 0 is for estimate
            if (print_on_invoice) {
                flag = 1; //if no invoice level disc, no checking needed
            } else {
                flag = 1; //if no invoice level disc, no checking needed
            }

            if (flag == 0) {
                this.data.override_disc_status = 1;

                let textInvoice = "invoice";
                if (!is_invoice) {
                    textInvoice = "estimate";
                }
                this.alertMessage = `Changing this item’s discount will remove the ${textInvoice}-level discount applied to this ${textInvoice}. Do you want to continue?`;
                this.isButtonTextContinue = true;
                this.canProceed = false;
                this.$emit("scroll-top");
            } else {
                this.data.override_disc_status = 0;
                this.alertMessage = null;
                this.canProceed = true;
                this.isButtonTextContinue = false;
            }
        },
        /**
         * @use estimate only
         * @method calculate_item_price_estimate
         * @description use only if there are changes in related to item
         */
        async calculate_item_price_estimate(arg) {
            let quantityMin = parseFloat(this.data.minQuantity);
            let quantityMax = parseFloat(this.data.maxQuantity);
            let defaultPrice = this.data.iitem_default_item_price;
            let defaultQty = this.data.iitem_default_quantity;
            let flag = 0;
            let origPrice = this.data.iitem_orig_item_price;
            let isMinPriceTier = this.data.is_min_price_tier;
            let minPrice = this.data.minimum_price;
            let minPriceType = this.data.minimum_price_type;
            let itemId = this.data.item ? this.data.item.id : null;
            let isCustomItemFromBundle = this.data.isCustomItemFromBundle;
            let defaultUnitPriceMin = parseFloat(this.data.defaultMinUnitPrice);
            let defaultUnitPriceMax = parseFloat(this.data.defaultMaxUnitPrice);
            let isAfterHours = this.invoiceItem
                ? this.invoiceItem.is_after_hours
                : null;

            // VET-2566 - Issue related to min/max price not following template price when is price tier is equal to 4
            let defaultTemplateUnitPriceMin = defaultUnitPriceMin;
            let defaultTemplateUnitPriceMax = defaultUnitPriceMax;
            if (this.data.bundleType == INVOICEITEM.BUNDLE_TYPE.ESTIMATE) {
                defaultTemplateUnitPriceMin = parseFloat(
                    this.data.templateData.unit_price
                );
                defaultTemplateUnitPriceMax = parseFloat(
                    this.data.templateData.max_unit_price
                );
            } else if (
                this.data.bundleType == INVOICEITEM.BUNDLE_TYPE.INVOICE
            ) {
                defaultTemplateUnitPriceMin = parseFloat(
                    this.data.templateData.unit_price
                );
                defaultTemplateUnitPriceMax = parseFloat(
                    this.data.templateData.unit_price
                );
            }

            defaultPrice = origPrice * defaultQty;
            if (quantityMax > -1 && quantityMin > quantityMax) {
                this.pushAlertMessages(
                    INVOICEITEM.ALERT_MESSAGE.LOW_VALUE_LOWER_THAN_HIGH
                );
                this.canProceed = false;
            } else {
                if (
                    this.alertMessages.includes(
                        INVOICEITEM.ALERT_MESSAGE.LOW_VALUE_LOWER_THAN_HIGH
                    )
                ) {
                    this.removeAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE.LOW_VALUE_LOWER_THAN_HIGH
                    );
                }
                this.canProceed = true;
            }

            let priceMin = 0;
            let priceMax = 0;
            if (arg == "min") {
                // @author Raja BSTP-355
                if (quantityMin % defaultQty == 0) {
                    priceMin = (quantityMin / defaultQty) * defaultPrice;
                } else {
                    priceMin = quantityMin * (defaultPrice / defaultQty);
                }

                //reset item unit price min
                if (isMinPriceTier == 1 || isMinPriceTier == 2) {
                    this.data.minUnitPrice = this.roundOff(
                        defaultUnitPriceMin
                    ).toFixed(2);
                    this.data.iitem_min_unit_price_ori = defaultUnitPriceMin;
                } else if (isMinPriceTier == 4 || isMinPriceTier == 5) {
                    this.data.minUnitPrice = this.roundOff(
                        defaultTemplateUnitPriceMin
                    ).toFixed(2);
                    this.data.iitem_min_unit_price_ori = defaultTemplateUnitPriceMin;
                }

                if (
                    (quantityMin > 0 && isMinPriceTier == 1) ||
                    isMinPriceTier == 2
                ) {
                    this.isPriceTier = false;

                    await InvoiceItemService.calculatePriceTier({
                        item_id: itemId,
                        quantity: quantityMin
                    }).then(res => {
                        let fee = this.data.iitem_fee_price;

                        // GIT #1979
                        if (minPriceType == 2) {
                            minPrice = minPrice * quantityMin;
                        }
                        // ---  apply price tier
                        if (parseFloat(res.discount) > 0) {
                            // --- set unit price after price tier discount
                            let unitPriceMin =
                                defaultUnitPriceMin -
                                defaultUnitPriceMin *
                                    (parseFloat(res.discount) / 100);

                            this.data.minUnitPrice = this.roundOff(
                                unitPriceMin
                            ).toFixed(2);
                            this.data.iitem_min_unit_price_ori = unitPriceMin;

                            priceMin = priceMin + parseFloat(fee);

                            if (priceMin < minPrice) {
                                //apply min price
                                priceMin = minPrice;
                            } else {
                                this.data.price_tier_min_id = res.id;
                                let discountAmount =
                                    priceMin * (parseFloat(res.discount) / 100);
                                priceMin = priceMin - discountAmount;
                                // priceMin = priceMin.toFixed(2);

                                if (priceMin < minPrice) {
                                    //apply min price
                                    priceMin = minPrice;
                                }
                            }
                            this.isPriceTier = true;
                        } else {
                            priceMin = priceMin + parseFloat(fee);
                            // --- apply min price
                            if (priceMin < minPrice) {
                                priceMin = minPrice;
                                this.data.minUnitPrice = this.roundOff(
                                    defaultUnitPriceMin
                                ).toFixed(2);
                                this.data.iitem_min_unit_price_ori = defaultUnitPriceMin;
                            }
                        }
                        priceMin = Math.round(priceMin * 100) / 100;
                        this.data.total_item_price_min = priceMin.toFixed(2);

                        if (
                            this.data.maxQuantity == null ||
                            this.data.maxQuantity === ""
                        ) {
                            this.data.maxUnitPrice = this.data.minUnitPrice;
                            this.data.iitem_max_unit_price_ori = this.data.iitem_min_unit_price_ori;
                            this.data.total_item_price_max = this.data.total_item_price_min;
                        }
                    });
                } else {
                    if (
                        isCustomItemFromBundle &&
                        (isMinPriceTier == 4 || isMinPriceTier == 5)
                    ) {
                        let defQty = this.data.iitem_default_quantity;
                        let defPrice = this.data.item.price;
                        let defUnitPrice = defPrice / defQty;
                        let fee = this.data.iitem_fee_price;
                        priceMin = quantityMin * defUnitPrice;
                        priceMin = priceMin + fee;

                        priceMin = Math.round(priceMin * 100) / 100;
                        this.data.total_item_price_min = priceMin.toFixed(2);
                    }
                }
            } else if (arg == "max") {
                if (
                    quantityMax > 0 &&
                    (isMinPriceTier == 1 || isMinPriceTier == 3)
                ) {
                    this.data.maxUnitPrice = this.roundOff(
                        defaultUnitPriceMax
                    ).toFixed(2);
                    this.data.iitem_max_unit_price_ori = defaultUnitPriceMax;
                } else if (isMinPriceTier == 4 || isMinPriceTier == 6) {
                    this.data.maxUnitPrice = this.roundOff(
                        defaultTemplateUnitPriceMax
                    ).toFixed(2);
                    this.data.iitem_max_unit_price_ori = defaultTemplateUnitPriceMax;
                }
                // @author Raja BSTP-3315
                if (quantityMax % defaultQty == 0) {
                    priceMax = (quantityMax / defaultQty) * defaultPrice;
                } else {
                    priceMax = quantityMax * (defaultPrice / defaultQty);
                }

                if (
                    (quantityMax > 0 && isMinPriceTier == 1) ||
                    isMinPriceTier == 3
                ) {
                    this.isPriceTier = false;

                    // either both min/max's unit not modified or max's unit not modified
                    await InvoiceItemService.calculatePriceTier({
                        item_id: itemId,
                        quantity: quantityMax
                    }).then(res => {
                        // GIT #1979
                        if (minPriceType == 2) {
                            minPrice = minPrice * quantityMax;
                        }
                        // this.data.minUnitPrice = this.roundOff(
                        //     defaultTemplateUnitPriceMin
                        // ).toFixed(2);
                        if (parseFloat(res.discount) > 0) {
                            // apply price tier
                            //@author:Stacy GIT#410:min price
                            let unitPriceMax =
                                defaultUnitPriceMax -
                                defaultUnitPriceMax *
                                    (parseFloat(res.discount) / 100);
                            if (quantityMax > 0) {
                                this.data.maxUnitPrice = this.roundOff(
                                    unitPriceMax
                                ).toFixed(2);
                                this.data.iitem_max_unit_price_ori = unitPriceMax;
                            }
                            if (priceMax < minPrice) {
                                //apply min price
                                priceMax = minPrice;
                            } else {
                                this.data.price_tier_max_id = res.id;
                                let discountAmount =
                                    priceMax * (parseFloat(res.discount) / 100);
                                priceMax = priceMax - discountAmount;
                                // priceMax = priceMax.toFixed(2);

                                if (priceMax < minPrice) {
                                    //apply min price
                                    priceMax = minPrice;
                                }
                            }
                            this.isPriceTier = true;
                        } else if (priceMax < minPrice) {
                            //apply min price
                            priceMax = minPrice;
                        }

                        priceMax = Math.round(priceMax * 100) / 100;
                        this.data.total_item_price_max = priceMax.toFixed(2);
                        if (
                            this.data.maxQuantity == null ||
                            this.data.maxQuantity === ""
                        ) {
                            this.data.maxUnitPrice = this.data.minUnitPrice;
                            this.data.iitem_max_unit_price_ori = this.data.iitem_min_unit_price_ori;
                            this.data.total_item_price_max = this.data.total_item_price_min;
                        }
                    });
                } else {
                    if (
                        isCustomItemFromBundle &&
                        (isMinPriceTier == 4 || isMinPriceTier == 6)
                    ) {
                        var defQty = this.data.iitem_default_quantity;
                        var defPrice = this.data.item.price;
                        var defUnitPrice = defPrice / defQty;
                        priceMax = quantityMax * defUnitPrice;

                        priceMax = Math.round(priceMax * 100) / 100;
                        this.data.total_item_price_max = priceMax.toFixed(2);
                    }
                }
            }
        },
        async calculate_item_price(is_from_quantity = false) {
            if (!is_from_quantity) {
                this.data.is_min_price_tier = 0;
            }

            let new_price = 0;
            let quantity = this.data.quantity;
            let unit_price = this.data.unitPrice;

            // @author Raja wellness
            let is_plan_active = this.data.is_plan_active;
            let plan_item_balance = this.data.plan_item_balance;
            let fees = this.data.iitem_item_fees;
            let is_min_price_tier = this.data.is_min_price_tier;
            let minimum_price = this.data.minimum_price;
            let print_on_invoice = this.data.isPrintOnInvoice;
            let iitem_fee_price = this.data.iitem_fee_price;
            let iitem_discount =
                this.data.discountAmount != null ? this.data.discountAmount : 0;
            let minimum_price_type = this.data.minimum_price_type;

            this.loading.push("calculate_item_price");
            if (minimum_price_type == 2) {
                minimum_price = minimum_price * quantity;
            }

            if (quantity > 0 && this.data.is_plan_item && is_plan_active > 0) {
                if (is_from_quantity && is_min_price_tier == 1) {
                    unit_price = this.data.iitem_orig_item_price;
                } else if (is_min_price_tier == 2) {
                    unit_price = this.data.iitem_unit_price_ori;
                }

                let balance = plan_item_balance - quantity;
                let plan_price = unit_price * quantity;
                let total_price = this._toNumber(0);

                if (!unit_price) {
                    this.data.iitem_unit_price_ori = 0;
                } else {
                    this.data.unitPrice = this._toNumber(unit_price, 2, false);
                    this.data.iitem_unit_price_ori = unit_price;
                }

                if (parseFloat(balance) >= 0) {
                    plan_price = quantity * unit_price;

                    this.data.fees = [];
                    this.data.total_item_price =
                        total_price +
                        " (" +
                        plan_price.toFixed(2) +
                        "  included in plan)";
                    this.data.iitem_price = total_price;
                    this.data.iitem_plan_price = plan_price;

                    this.calculate_discount(1);
                } else {
                    total_price = (
                        Math.abs(balance) * unit_price +
                        parseFloat(iitem_fee_price) -
                        parseFloat(iitem_discount)
                    ).toFixed(2);
                    plan_price = (plan_item_balance * unit_price).toFixed(2);

                    if (fees && this.data.fees.length == 0) {
                        this.data.fees = fees;
                        this.data.iitem_fee_price = this.data.default_iitem_fee_price;
                    }

                    if (
                        is_from_quantity &&
                        is_min_price_tier == 1 &&
                        this.data.item
                    ) {
                        // calculate_price_tier
                        await InvoiceItemService.calculatePriceTier({
                            item_id: this.data.item.id,
                            quantity: this.data.quantity
                        }).then(res => {
                            var float_price = parseFloat(unit_price);

                            if (res.discount > 0) {
                                var discount =
                                    unit_price *
                                    (parseFloat(res.discount) / 100);
                                float_price = unit_price - discount;
                                unit_price = float_price;
                            }
                            if (total_price > parseFloat(minimum_price)) {
                                let discount_amount =
                                    total_price *
                                    (parseFloat(res.discount) / 100);
                                total_price = total_price - discount_amount;

                                if (
                                    parseFloat(total_price) <=
                                    parseFloat(minimum_price)
                                ) {
                                    total_price = parseFloat(minimum_price);
                                }
                            } else {
                                total_price = parseFloat(minimum_price).toFixed(
                                    2
                                );
                            }

                            if (
                                parseFloat(Math.abs(balance)) > 0 &&
                                parseFloat(minimum_price) > 0 &&
                                parseFloat(total_price) ==
                                    parseFloat(minimum_price)
                            ) {
                                this.data.total_item_price =
                                    this._toNumber(total_price, 2) +
                                    " (minimum price, " +
                                    this._toNumber(plan_price, 2) +
                                    "  included in plan)";
                            } else {
                                this.data.total_item_price =
                                    this._toNumber(total_price, 2) +
                                    " (" +
                                    this._toNumber(plan_price, 2) +
                                    "  included in plan)";
                            }

                            this.data.iitem_price = total_price;
                            this.data.iitem_plan_price = plan_price;
                            this.data.unitPrice = this._toNumber(
                                unit_price,
                                2,
                                false
                            );
                            this.data.iitem_unit_price_ori = float_price;
                        });
                    } else {
                        this.data.total_item_price =
                            parseFloat(total_price).toFixed(2) +
                            " (" +
                            parseFloat(plan_price).toFixed(2) +
                            "  included in plan)";
                        this.data.iitem_price = total_price;
                        this.data.iitem_plan_price = plan_price;
                    }
                }
            } else {
                if (is_from_quantity && is_min_price_tier == 1) {
                    unit_price = this.data.iitem_orig_item_price;
                } else if (is_min_price_tier == 2) {
                    unit_price = this.data.iitem_unit_price_ori;
                } else {
                    // min and price_tier no more applicable
                    unit_price = this.data.unitPrice;
                }

                new_price = unit_price * quantity;

                if (
                    quantity > 0 &&
                    is_from_quantity &&
                    is_min_price_tier == 1
                ) {
                    this.data.price_tier_id = null;

                    await InvoiceItemService.calculatePriceTier({
                        item_id: this.data.item.id,
                        quantity: this.data.quantity
                    }).then(res => {
                        if (parseFloat(res.discount) > 0) {
                            // apply price tier
                            //unit price less price tier discount
                            unit_price =
                                unit_price -
                                unit_price * (parseFloat(res.discount) / 100);

                            if (new_price <= parseFloat(minimum_price)) {
                                //apply min price
                                new_price = parseFloat(minimum_price);
                            } else {
                                this.data.price_tier_id = res.id;

                                let discount_amount =
                                    new_price *
                                    (parseFloat(res.discount) / 100);
                                new_price = new_price - discount_amount;

                                if (new_price <= parseFloat(minimum_price)) {
                                    //apply min price
                                    new_price = parseFloat(minimum_price);
                                } else {
                                    if (new_price <= unit_price) {
                                        new_price =
                                            quantity * unit_price -
                                            discount_amount;
                                    }
                                }
                            }
                        } else if (new_price < parseFloat(minimum_price)) {
                            //apply min price
                            new_price = parseFloat(minimum_price);
                        }

                        if (print_on_invoice) {
                            if (
                                parseFloat(quantity) > 0 &&
                                parseFloat(minimum_price) > 0 &&
                                parseFloat(new_price) ==
                                    parseFloat(minimum_price)
                            ) {
                                this.data.total_item_price =
                                    this._toNumber((new_price * 100) / 100, 2) +
                                    " (minimum price)";
                            } else {
                                var rounded_number = this.round_number(
                                    new_price,
                                    2
                                );
                                this.data.total_item_price = this._toNumber(
                                    rounded_number,
                                    2
                                );
                            }

                            this.data.iitem_price = this._toNumber(
                                (new_price * 100) / 100,
                                2
                            );

                            if (isFinite(unit_price) > 0) {
                                this.data.iitem_unit_price_ori = unit_price;

                                unit_price = unit_price
                                    ? parseFloat(unit_price).toFixed(2)
                                    : 0;

                                this.data.unitPrice = this._toNumber(
                                    unit_price,
                                    2,
                                    false
                                );
                            } else {
                                this.data.unitPrice = this._toNumber(
                                    0,
                                    2,
                                    false
                                );
                                this.data.iitem_unit_price_ori = 0;
                            }

                            if (fees && this.data.fees.length == 0) {
                                this.data.fees = fees;
                                this.data.iitem_fee_price = this.data.default_iitem_fee_price;
                            }
                        }
                    });
                } else {
                    // min and price_tier no more applicable
                    if (print_on_invoice) {
                        new_price = (new_price * 100) / 100;

                        this.data.iitem_price = new_price.toFixed(2);
                        this.data.total_item_price = new_price.toFixed(2);

                        if (fees) {
                            if (this.data.fees.length == 0) {
                                this.data.fees = fees;
                            }

                            this.data.iitem_fee_price = this.data.default_iitem_fee_price;

                            this.data.total_item_price = this._toNumber(
                                new_price +
                                    parseFloat(this.data.iitem_fee_price),
                                2
                            );
                        }
                    }
                }
            }
            this.removeLoadingItem("calculate_item_price");
        },
        /**
         * @use estimate and invoice
         * @method calculate_discount
         */
        async calculate_discount(is_saved_discount) {
            if (this.isInvoice && isNaN(parseFloat(this.data.quantity))) {
                return;
            } else if (
                !this.isInvoice &&
                isNaN(parseFloat(this.data.minQuantity))
            ) {
                return;
            }

            this.loading.push("calculate_discount");
            let params = {
                status: Number(this.isInvoice), // 1=Invoice, 0=Estimate
                invoice_id: this.isInvoice ? this.invoice.id : this.estimate.id, // Invoice/Estimate id
                iitem_id: this.invoiceItem ? this.invoiceItem.id : null, // Invoice item/Estimate item id
                quantity: this.isInvoice
                    ? this.data.quantity
                    : this.data.minQuantity,
                price: this.data.iitem_price,
                fees: this.feesId,
                discount_id: this.data.discountId,
                discount: this.data.discountAmount,
                discount_type: this.data.discountType,
                is_non_plan_item: this.data.is_non_plan_item,
                print_on_invoice: this.data.isPrintOnInvoice,
                price_max: this.isInvoice ? 0 : this.data.total_item_price_max, // CI send 0 // for estimate
                quantity_max: this.isInvoice ? 0 : this.data.maxQuantity, // CI send 0 // for estimate
                temp_poi: this.data.previousIsPrintOnInvoice, // in BE to trigger recalculate discount
                item_id: this.data.item ? this.data.item.id : null,
                patient_id: this.data.patient ? this.data.patient.id : null,
                type: this.isInvoice ? "invoice" : "estimate",
                min_price: this.data.minimum_price,
                unit_price: this.isInvoice
                    ? this.data.is_min_price_tier == 0
                        ? this.data.unitPrice
                        : this.data.iitem_unit_price_ori
                    : parseFloat(this.data.minUnitPrice),
                unit_price_max: this.isInvoice
                    ? 0
                    : parseFloat(this.data.maxUnitPrice), // CI send 0 // for estimate
                isAfterHours: this.invoiceItem
                    ? this.invoiceItem.is_after_hours
                    : null,
                is_saved_discount: is_saved_discount,
                invoice_discount_id: this.data.invoice_discount_id
            };

            const res = await InvoiceItemService.calculateDiscount(params);

            if (!res) {
                this._message("Error", "danger");
                this.removeLoadingItem("calculate_discount");
                return;
            }
            if (res.is_invoice_discount) {
                this.data.invoice_discount_id = res.discount_id;
                this.data.invoice_discount_amount = res.discount_amount;
                this.data.invoice_discount_item_id =
                    res.invoice_discount_item_id;
            }

            this.data.discountAmount = res.discount_amount;
            this.data.discountType = res.discount_type ? res.discount_type : 0;

            // --- reset after compared client/wellness discount
            this.data.is_non_plan_item = this.checkBoolean(res.is_non_plan);

            if (res.is_non_plan) {
                res.is_wellness_discount = true; // used in update_discount_field
            }

            if (this.isNew) {
                this.data.iitem_item_discount = res.discount_amount;
            }

            // if (this.isInvoice) {
            //     this.recalculate_invoice_total();
            // } else {
            //     // For estimate migration
            //     // this.recalculate_estimate_total();
            // }
            // }

            await this.update_discount_field(res, res.discount_id);
            this.removeLoadingItem("calculate_discount");
        },
        update_discount_field(data, discountId) {
            // Compared to the code from CI, we are currently using API discounts getDiscountsByItem;
            // --- if invoice level dollar discount applied to this item
            let isInvoiceEstimateDiscount = this.isInvoice
                ? data.is_invoice_discount
                : data.is_estimate_discount;
            if (isInvoiceEstimateDiscount) {
                const isHasOpt2 = find(this.discountOptions, {
                    id: INVOICEITEM.DISCOUNTS.INVOICE.id
                });
                if (!isHasOpt2) {
                    this.discountOptions.push(INVOICEITEM.DISCOUNTS.INVOICE);
                }
                this.data.discountId = INVOICEITEM.DISCOUNTS.INVOICE.id;
                this.data.discountType = 0;
                this.data.discountAmount = 0;
            } else if (data.is_wellness_discount) {
                const isHasOpt3 = find(this.discountOptions, {
                    id: INVOICEITEM.DISCOUNTS.WELLNESS.id
                });
                if (!isHasOpt3) {
                    this.discountOptions.push(INVOICEITEM.DISCOUNTS.WELLNESS);
                }
                this.data.discountId = INVOICEITEM.DISCOUNTS.WELLNESS.id;
                // --- in apps if wellness discount, the discount amount field will be hidden, but the value remained
                // this.data.discountType = 0;
                // this.data.discountAmount = 0;
            } else if (
                discountId != INVOICEITEM.DISCOUNTS.CUSTOM.id &&
                this.data.item != null &&
                discountId // check like this to check the value
            ) {
                this.data.discountId = discountId;
            }
        },
        async check_negative_invoice_total() {
            let quantity = 0;
            let quantity_max = 0;
            let total_item_price = null;
            let total_item_price_min = null;
            let total_item_price_max = null;
            if (this.isInvoice) {
                total_item_price = parseFloat(
                    this.data.total_item_price.replace(",", "")
                ); // to convert value with comma or string to float
            } else {
                total_item_price_min = parseFloat(
                    this.data.total_item_price_min
                );

                total_item_price_max = parseFloat(
                    this.data.total_item_price_max
                );
            }

            this.loading.push("check_negative_invoice_total");

            if (!this.isInvoice) {
                // for estimate
                quantity = this.data.minQuantity;
                quantity_max = this.data.maxQuantity;
            } else {
                quantity = this.data.quantity;
            }

            let params = {
                status: Number(this.isInvoice), // 1=Invoice, 0=Estimate
                invoice_id: this.isInvoice ? this.invoice.id : this.estimate.id,
                iitem_id: this.invoiceItem ? this.invoiceItem.id : null,
                iitem_price: total_item_price,
                iitem_price_min: total_item_price_min,
                iitem_price_max: total_item_price_max,
                fees: this.feesId,
                quantity: Number(quantity),
                quantity_max: quantity_max,
                discount_id: this.data.discountId,
                discount_amount: this.data.invoice_discount_id
                    ? this.data.invoice_discount_amount
                    : 0,
                discount_item_id: this.data.invoice_discount_id
                    ? this.data.invoice_discount_item_id
                    : null,
                invoice_discount_id: this.data.invoice_discount_id,
                item_id: this.data.item ? this.data.item.id : null
            };

            await InvoiceItemService.calculateNegativeInvoiceTotal(params)
                .then(res => {
                    if (res) {
                        this.data.remove_invoice_discount = false;
                        this.isInvoice
                            ? this.handleNegativeResultCheckingInvoice(res)
                            : this.handleNegativeResultCheckingEstimate(res);
                    } else {
                        throw new Error(
                            `Failed to calculate if ${
                                this.isInvoice ? "invoice" : "estimate"
                            } is negative`
                        );
                    }
                })
                .catch(error => {
                    this._message(error, "danger");
                })
                .finally(() => {
                    this.removeLoadingItem("check_negative_invoice_total");
                });
        },
        handleNegativeResultCheckingInvoice(res) {
            const message = INVOICEITEM.ALERT_MESSAGE.INVOICE_NEGATIVE;
            if (res.negative_invoice == false) {
                this.alertMessage = null;
                this.canProceed = true;
            } else {
                if (res.remove_invoice_discount == true) {
                    this.alertMessage = res.remove_invoice_discount_msg;
                    this.data.remove_invoice_discount = true;
                } else {
                    this.alertMessage = message;
                    this.data.override_disc_status = 0;
                }
                this.canProceed = false;
                this.$emit("scroll-top");
            }
        },
        handleNegativeResultCheckingEstimate(res) {
            if (res.negative_invoice === false) {
                // use by estimate, invoice will be change later
                if (
                    this.alertMessages.includes(
                        INVOICEITEM.ALERT_MESSAGE.ESTIMATE_NEGATIVE
                    )
                ) {
                    this.removeAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE.ESTIMATE_NEGATIVE
                    );
                }
                this.canProceed = true;
            } else {
                if (res.remove_invoice_discount == true) {
                    // use by estimate, invoice will be change later
                    this.pushAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE.REMOVE_DISCOUNT_MESSAGE
                    );

                    this.data.remove_invoice_discount = true;
                } else {
                    // use by estimate, invoice will be change later
                    if (
                        this.alertMessages.includes(
                            INVOICEITEM.ALERT_MESSAGE.REMOVE_DISCOUNT_MESSAGE
                        )
                    ) {
                        this.removeAlertMessages(
                            INVOICEITEM.ALERT_MESSAGE.REMOVE_DISCOUNT_MESSAGE
                        );
                    }
                    // use by estimate, invoice will be change later
                    this.pushAlertMessages(
                        INVOICEITEM.ALERT_MESSAGE.ESTIMATE_NEGATIVE
                    );

                    this.data.override_disc_status = 0;
                }
                this.canProceed = false;
                this.$emit("scroll-top");
            }
        },

        async set_plan_price() {
            // only accept invoice and invoice with status Open and Reopened
            if (
                !(
                    this.isInvoice &&
                    this.invoice &&
                    (this.invoice.status == BILLINGS.INVOICE.TYPE_OPEN ||
                        this.invoice.status == BILLINGS.INVOICE.TYPE_REOPENED)
                )
            ) {
                return;
            }

            let quantity = this.data.quantity;
            let minimum_price = this.data.minimum_price;
            let minimum_price_type = this.data.minimum_price_type;
            let previous_plan_item = this.data.is_plan_item;
            let previous_non_plan_item = this.data.is_non_plan_item;
            let is_min_price_tier = this.data.is_min_price_tier;
            let fees = this.data.iitem_item_fees;
            let unit_price = this.data.iitem_unit_price_ori;

            if (is_min_price_tier == 1) {
                // BSTP-4112
                unit_price = this.data.iitem_orig_item_price;
            }

            // GIT #1979
            if (minimum_price_type == 2) {
                minimum_price = minimum_price * quantity;
            }

            await InvoiceItemService.getPlanByPatient({
                patient_id: this.data.patient ? this.data.patient.id : null,
                item_id: this.data.item ? this.data.item.id : null,
                unit_price: unit_price,
                quantity: quantity,
                item_type_category_id:
                    this.data.item && this.data.item.item_type_category_id,
                plan_item_balance: this.data.plan_item_balance,
                invoice_id: this.invoice.id, // Invoice id
                invoice_item_id: this.invoiceItem ? this.invoiceItem.id : null,
                is_min_price_tier: this.data.is_min_price_tier
            }).then(res => {
                if (this.data.patient && this.data.item) {
                    if (res.is_plan == true) {
                        var balance =
                            parseFloat(res.balance) -
                            parseFloat(this.data.quantity);

                        if (
                            parseFloat(Math.abs(balance)) > 0 &&
                            parseFloat(this.data.minimum_price) > 0 &&
                            parseFloat(res.total_price) ==
                                parseFloat(this.data.minimum_price)
                        ) {
                            this.data.total_item_price = `${
                                res.formatted_total_price
                            } (minimum, ${this._toNumber(
                                res.plan_price,
                                2
                            )} included in plan)`;
                        } else {
                            this.data.total_item_price = `${
                                res.formatted_total_price
                            } (${this._toNumber(
                                res.plan_price,
                                2
                            )} included in plan)`;
                        }

                        this.data.is_plan_active = 1;
                        this.data.plan_item_balance = res.balance;
                        this.data.iitem_price = res.total_price;
                        this.data.iitem_plan_price = res.plan_price;
                        this.data.unitPrice = this._toNumber(
                            res.unit_price,
                            2,
                            false
                        );
                        this.data.iitem_unit_price_ori = this._toNumber(
                            res.unit_price,
                            2
                        );
                        this.data.priceTierId = res.price_tier_id;

                        if (balance >= 0) {
                            // remove fees and tax if total price is $0
                            this.data.fees = [];
                            this.data.is_non_plan_item = false;
                            this.data.discountAmount = 0;
                            this.data.discountType = 0;
                        } else {
                            if (fees && this.data.fees.length == 0) {
                                this.data.fees = fees;

                                this.data.fees_price = this.invoiceItem
                                    ? this.invoiceItem.fee
                                    : 0;
                            }

                            if (res.is_non_plan) {
                                this.data.is_non_plan_item = true;
                                this.data.discountAmount = res.non_plan_disc;
                                this.data.discountType = 0;
                            }
                        }

                        this.data.is_non_plan_item = false;
                        this.data.is_plan_item = true;
                    } else if (res.is_non_plan == true) {
                        this.data.discountType = 0;
                        this.data.discountAmount = res.non_plan_disc;
                        this.data.is_non_plan_item = true;

                        if (
                            parseFloat(quantity) > 0 &&
                            parseFloat(minimum_price) > 0 &&
                            parseFloat(res.total_price) ==
                                parseFloat(minimum_price)
                        ) {
                            this.data.total_item_price =
                                res.formatted_total_price + " (minimum price)";
                        } else {
                            this.data.total_item_price =
                                res.formatted_total_price;
                        }

                        if (fees && this.data.fees.length == 0) {
                            this.data.fees = fees;
                            this.data.fees_price = this.invoiceItem
                                ? this.invoiceItem.fee
                                : 0;
                        }
                    } else {
                        if (
                            parseFloat(quantity) > 0 &&
                            parseFloat(minimum_price) > 0 &&
                            parseFloat(res.total_price) ==
                                parseFloat(minimum_price)
                        ) {
                            this.data.total_item_price =
                                res.formatted_total_price + " (minimum price)";
                        } else {
                            this.data.total_item_price =
                                res.formatted_total_price;
                        }

                        this.data.unitPrice = this._toNumber(
                            res.unit_price,
                            2,
                            false
                        );
                        this.data.iitem_price = res.total_price;
                        this.data.iitem_unit_price_ori = res.unit_price;

                        this.data.fees = fees;
                        this.data.fees_price = this.invoiceItem
                            ? this.invoiceItem.fee
                            : 0;

                        // ---  if previously non plan item
                        if (this.data.is_non_plan_item) {
                            this.data.discountAmount = 0;
                            this.data.discountType = 0;
                        }

                        this.data.is_plan_item = false;
                        this.data.is_non_plan_item = false;
                    }
                } else {
                    this.data.is_plan_item = false;
                    this.data.is_non_plan_item = false;

                    if (previous_plan_item == 1) {
                        // reset total price

                        this.data.total_item_price = res.formatted_total_price;

                        this.data.iitem_price = res.total_price;
                        this.data.unitPrice = this._toNumber(
                            res.unit_price,
                            2,
                            false
                        );
                        this.data.fees = fees;
                        this.data.fees_price = this.invoiceItem
                            ? this.invoiceItem.fee
                            : 0;
                    } else if (previous_non_plan_item == 1) {
                        this.data.discountAmount = 0;
                        this.data.discountType = 0;
                    }

                    if (
                        parseFloat(quantity) > 0 &&
                        parseFloat(minimum_price) > 0 &&
                        parseFloat(res.total_price) == parseFloat(minimum_price)
                    ) {
                        this.data.total_item_price =
                            res.formatted_total_price + " (minimum price)";
                    } else {
                        this.data.total_item_price = res.formatted_total_price;
                    }
                }
            });
        },
        round_number(number, precision) {
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
            var factor = Math.pow(10, precision);
            var factored_num = number * factor;
            var rounded_fac_num = Math.round(factored_num);

            return rounded_fac_num / factor;
        },
        validate_quantity(name) {
            let fieldName = name;
            let currentVal = this.data.is_min_price_tier;

            if (fieldName == "min") {
                var unitPriceMin = parseFloat(this.data.minUnitPrice);

                if (
                    (this.data.fees == "" || this.data.fees == null) &&
                    parseFloat(unitPriceMin) == 0
                ) {
                    this.data.total_item_price_min = parseFloat(0).toFixed(2);
                }

                if (currentVal == 1) this.data.is_min_price_tier = 3;
                // BSTP-4112
                else if (currentVal == 4) this.data.is_min_price_tier = 6;
                // BSTP-4112
                else this.data.is_min_price_tier = 0; // BSTP-4112
            }

            if (fieldName == "max") {
                if (currentVal == 1) this.data.is_min_price_tier = 2;
                // BSTP-4112
                else if (currentVal == 4) this.data.is_min_price_tier = 5;
                // BSTP-4112
                else this.data.is_min_price_tier = 0; // BSTP-4112
            }
        }
    }
};
